export const navs = [{
  label: '车漆',
  value: 'exteriors',
  icon: 'exteriors'
  // icon: '\ue602'
}, {
  label: '车轮',
  value: 'wheels',
  icon: 'wheels'
  // icon: '\ue601'
}, {
  label: '场景',
  value: 'scenes',
  icon: 'scenes'
  // icon: '\ue603'
}, {
  label: 'AR实验室',
  value: 'setting',
  icon: 'setting'
  // icon: '\ue605'
}];

export const settingNavs = [{
  // icon: '\ue612',
  icon: 'back',
  value: 'back'
}, {
  // icon: '\ue62e',
  icon: 'speed',
  value: 'speed',
  label: '百KM加速'
}, {
  // icon: '\ue604',
  icon: 'differ',
  value: 'differ',
  label: '两车对比'
}, {
  // icon: '\ue608',
  icon: 'doors',
  value: 'doors',
  label: '打开车门'
}, {
  // icon: '\ue606',
  icon: 'windows',
  value: 'windows',
  label: '升降车窗'
}]

export function getSubNavs(carOptions) {
  return {
    exteriors: getExteriors(carOptions),
    interiors: getInteriors(carOptions),
    views: getViewsList(carOptions),
    wheels: getWheels(carOptions),
    scenes: getScenes(carOptions),
    speed: [],
    differ: []
  }
}

function getExteriors(carOptions) {
  if (carOptions && carOptions.exterior) {
    return carOptions.exterior.map((v, i) => {
      return {
        name: v.name,
        uid: v.uid,
        bg: v.color
      };
    });
  } else {
    return [];
  }
}

function getWheels(carOptions) {
  if (carOptions && carOptions.wheel) {
    return carOptions.wheel.slice(0, 4).map((v, i) => {
      return {
        name: ['原厂', '选装A', '选装B'][i],
        uid: v.uid,
        // icon: '\ue601'
        bg: 'lunzi-' + (i + 1) + '.png'
      };
    });
  } else {
    return [];
  }
}

function getScenes(carOptions) {
  if (carOptions && carOptions.scene) {
    // const skys = browser('mobile') ? carOptions.scene.slice(0, 4) : carOptions.scene;
    // const sorts = ['废弃船厂', '花生好车定制场景3', '花生好车定制场景1', '黄昏', '空间二'];
    const sorts = [
      '场景1',
      '场景2',
      '场景3',
      '场景4',
    ];
    const names = [
      '天空', '外滩', '草原', '影棚'
    ]
    const skys = [];
    sorts.forEach((name) => {
      if (carOptions && carOptions.scene) {
        const res = carOptions.scene.find((v) => v.name === name);
        if (res) {
          skys.push(res);
        }
      }
    });

    return skys.map((v, i) => {
      let icon = '';
      switch (i) {
        case 0:
          icon = 'scene6.jpg';
          break;
        case 1:
          icon = 'scene7.jpg';
          break;
        case 2:
          icon = 'scene2.jpg';
          break;
        case 3:
          icon = 'scene5.jpg';
          break;
        case 4:
          icon = 'scene1.jpg';
          break;
        default:
          icon = 'scene3.jpg';
          break;
      }
      return {
        name: names[i] || v.name,
        uid: v.uid,
        bg: icon
      };
    });
  } else {
    return [];
  }
}

export function getInteriors(carOptions) {
  if (carOptions && carOptions.interior) {
    return carOptions.interior.map((v, i) => {
      return {
        name: v.name,
        uid: v.uid,
        bg: v.color,
      };
    });
  } else {
    return [];
  }
}

export function getViewsList(carOptions) {
  if (carOptions && carOptions.view) {
    const icons = ['', '\ue608', '\ue607', '\ue609'];
    return carOptions.view.map((v, i) => {
      return {
        name: v.name,
        uid: v.uid,
        icon: icons[i],
      };
    });
  } else {
    return [];
  }
}